import './header.scss';
import { Button, Modal, ModalBody, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import React from 'react';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
export interface HeaderRegProps extends StateProps, DispatchProps {}
class HeaderReg extends React.Component<HeaderRegProps> {
  componentWillMount() {
    window['is_mobile']();
  }

  handleOnclick = () => {
    if (window['isMobile']) {
      window.location.href = this.props.config.deepLink;
      let timerId = setTimeout(() => {
        window.location.href = this.props.config.urlDVC;
      }, 25);
    } else {
      window.location.href = this.props.config.urlDVC;
    }
  };

  render() {
    return (
      <div className="header-logo">
        <div className="logo-text">
          <a className="logo">
            <img src={require('../../../images/header/logo.jpg')} alt="" />
          </a>
          <div>
            <Row style={{ justifyContent: 'center' }}>
              <a>NỀN TẢNG QUẢN LÝ ĐỊNH DANH VÀ XÁC THỰC BỘ NÔNG NGHIỆP VÀ MÔI TRƯỜNG</a>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  config: storeState.applicationProfile.config
});

const mapDispatchToProps = {};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderReg);
